// Import modules...
import { createApp, h } from 'vue';
import { createInertiaApp, Head, Link, usePage } from '@inertiajs/vue3'; // Updated import

// No longer needed: import { InertiaProgress } from '@inertiajs/progress';

const el = document.getElementById('app');

createInertiaApp({
    resolve: name => require(`./Pages/${name}`).default,
    setup({ App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mixin({ methods: { route } });
        
        app.mount(el);
    },

    // Progress customization moved here if needed
    progress: {
        color: '#4B5563'
    },
    // Add any other options you previously had
});

// No longer needed: InertiaProgress.init({ color: '#4B5563' });
